import type { HTMLAttributes } from 'react'

import React from 'react'

import { cn } from '@/shared/lib/utils'

type BlanketProps = {
	/** Whether mouse events can pierce the blanket. If true, onBlanketClicked will not be fired */
	canClickThrough?: boolean
	/** Whether the blanket has a tinted background color. */
	isTinted?: boolean
	/** Handler function to be called when the blanket is clicked */
	onBlanketClicked?: (event: React.MouseEvent<HTMLDivElement>) => void
	/** Ref to be attached to the blanket element */
	ref?: React.Ref<HTMLDivElement>
} & HTMLAttributes<HTMLDivElement>

const Blanket = ({
	canClickThrough,
	isTinted,
	onBlanketClicked,
	className,
	ref,
	...props
}: BlanketProps) => {
	const onClick = canClickThrough ? undefined : onBlanketClicked

	return (
		<div
			data-slot='blanket'
			{...props}
			ref={ref}
			data-tinted={isTinted}
			onClick={onClick}
			className={cn(
				'pointer-events-none fixed top-0 right-0 bottom-0 left-0 z-50 bg-black/35 opacity-0 transition-all dark:bg-black/50',
				className,
				{
					'pointer-events-auto opacity-100': isTinted,
					'pointer-events-none': isTinted && canClickThrough,
				}
			)}
		/>
	)
}
Blanket.displayName = 'Blanket'
export { Blanket, type BlanketProps }
